export { EditPassword } from './EditPassword';
export { ConfirmEmail } from './ConfirmEmail';
export { UnlockAccount } from './UnlockAccount';
export { AutoRegistrationModal } from './AutoRegistration';
